/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController, AlertController, ToastController } from '@ionic/angular';
import { TermsComponent } from '@shared/components/terms/terms.component';
import { AuthenticationService } from '@shared/services/authentication.service';
import { UtilService } from '@shared/utils/util';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserModel } from '@shared/models/user.model';
import { LocationService } from '@shared/services/location.service';
import { GoogleAuth } from '@southdevs/capacitor-google-auth';
import { UserService } from '@shared/services/user.service';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';
import { HttpClient } from '@angular/common/http';
import { FcmService } from '@shared/services/fcm.service';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Capacitor } from '@capacitor/core';
import { GoogleWebAuthService } from 'src/app/services/google-web-auth.service';
import { AppComponent } from 'src/app/app.component';
import { LoginSharedPage } from '../login-shared/login-shared.page';
import { PushNotifications } from '@capacitor/push-notifications';
import { FirebaseCrashlyticsService } from '@shared/services/firebase-crashlytics.service';
import { environment, webVersion } from 'src/environments/environment';
import { FacebookService } from '@shared/services/facebook.service';
import { FacebookUser } from '@shared/interfaces/facebook-user-interface';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import { MatchService } from 'src/app/services/match.service';
import { SignInWithApple, SignInWithAppleResponse, SignInWithAppleOptions } from '@capacitor-community/apple-sign-in';
import { OnboardingService } from '@shared/services/onboarding.service';
import { SignupWithEmailPage } from '../signup-with-email/signup-with-email.page';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  providers: [UtilService],
})
export class LoginPage implements OnInit {
  public showWebAuthentication = false;
  public showNativeWebLogin = false;
  public affiliateLandingHtml = '';

  public isNative: boolean = this.util.isNative();
  public isIos: boolean = true;
  public deviceInfo: any;
  public userData: any = {}; // Initialize with an empty object
  public imageFB: string = '';
  public processingAppleSignin: boolean = false;
  public processingGoogleSignin: boolean = false;
  public processingFacebookSignin: boolean = false;

  public userLoggedIn: boolean = false;
  private createAccountSocial: 'google' | 'facebook' | 'apple' | null = null;
  constructor(
    private fcm: FcmService,
    private facebookService: FacebookService,
    private http: HttpClient,
    private userModel: UserModel,
    public analytics: AnalyticsService,
    private authenticationService: AuthenticationService,
    private modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    private util: UtilService,
    private alertCtrl: AlertController,
    public platform: Platform,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    private userService: UserService,
    private locationService: LocationService,
    public firebaseCrashlytics: FirebaseCrashlyticsService,
    public router: Router,
    private matchService: MatchService,
    private googleWebAuth: GoogleWebAuthService,
    private onboardingService: OnboardingService,
  ) {
    this.util.initTranslate();
    this.userModel = new UserModel();
    this.isNative = this.util.isNative();
    this.isIos = !platform.is('android');
    this.initializeApp();
    //this.startVideo();
  }

  async ionViewWillEnter() {
    this.loadAffiliateLanding();
    this.userLoggedIn = localStorage.getItem('USER_LOGGED') ? true : false;

    // WEB: pré-carrega o GIS para que o clique em "Entrar com Google" seja síncrono
    // (o gapi.auth2 legado do plugin foi desligado pelo Google).
    if (!Capacitor.isNativePlatform()) {
      this.googleWebAuth.preload(environment.googleAuth.web).catch((e) => console.warn('GIS preload:', e));
    }

    if (this.isNative) {
      if (this.platform.is('android') && parseInt((await Device.getInfo()).osVersion) > 12) {
        await this.registerNotifications()
      }

    }

    this.util.initTranslate();

    const social = new URLSearchParams(window.location.search).get('social');
    if (social === 'google' || social === 'facebook' || social === 'apple') {
      void this.startCreateAccountSocial(social);
      void this.router.navigate(['/login'], { queryParams: {}, replaceUrl: true });
    }

    if (localStorage.getItem('USER_LOGGED')) {
      this.router.navigateByUrl('/tabs/home');
      return;
    }

    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      val = val.value ? JSON.parse(val.value) : null;
      this.userData = val;
      //this.ensureTerms();
    });

    // this.startVideo();
  }

  ionViewWillLeave() {
  }


  registerNotifications = async () => {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping push notification registration');
      return;
    }

    try {
      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== 'granted') {
        console.log('Push permission not granted, skipping register');
        return;
      }

      await PushNotifications.register();
    } catch (error) {
      console.error('Error registering push notifications:', error);
    }
  }

  private ensureTerms(): boolean {

    const tempURL = document.URL;
    const isDeepLink: boolean = tempURL.includes("referralUserId") || tempURL.includes("unsubscribe")

    if (AppComponent.isUnsubscribe || isDeepLink) {
      AppComponent.isUnsubscribe = false;
      return true;// No need to show terms for unsubscribe
    }

    if (this.userData != null && this.userData.termsAcceptedOn != null) {
      Preferences.set({ key: 'TERMS_ACCEPTED_ON', value: JSON.stringify(this.userData.termsAcceptedOn) }).then((_val) => {
        console.log('termsAcceptedOn saved to DB');
      });
      return true;
    }


    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      val = val.value ? JSON.parse(val.value) : null;
      console.log('val inside ensureTerms: ' + val);

      if (val != null) {
        this.userData = val;
        console.log('val inside ensureTerms: ' + val);
        if (this.userData.termsAcceptedOn != null) {
          Preferences.set({ key: 'TERMS_ACCEPTED_ON', value: JSON.stringify(this.userData.termsAcceptedOn) }).then((_val) => {
            console.log('termsAcceptedOn saved to DB');
          });
          return true;
        } else {
          Preferences.get({ key: 'TERMS_ACCEPTED_ON' }).then((val) => {
            val = val.value ? JSON.parse(val.value) : null;
            if (val == null) {
              this.displayLoginShared();
              return false;
            } else {
              this.userData.termsAcceptedOn = val;
              Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((_val) => {
                console.log('userdata saved to DB');
              });
              return true;
            }
          });
        }
      } else {
        console.log('val inside ensureTerms is null. Will determine if termsAcceptedOn is set..');
        Preferences.get({ key: 'TERMS_ACCEPTED_ON' }).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          console.log('termsAcceptedOn stored: ' + val);
          if (val == null) {
            this.displayTerms();
            return false;
          } else {
            return true;
          }
        });
      }

      return true; //!!!!!!!
    })

    return true;

  }

  private async displayLoginShared() {
    console.log('displayTerms..');
    const modal = this.modalCtrl.create({ component: LoginSharedPage, componentProps: { needsAcceptance: true } });
    (await modal).present();
  }

  private async displayTerms() {
    console.log('displayTerms..');
    const modal = this.modalCtrl.create({ component: TermsComponent, componentProps: { needsAcceptance: true } });
    (await modal).present();

  }


  async ngOnInit() {
    this.getDevice();
  }


  initializeApp() {
    this.platform.ready().then(async () => {
      if (!Capacitor.isNativePlatform()) {
        await FacebookLogin.initialize({ appId: '958355687655700' });
      }

    })
  }

  async getDevice() {
    const device = await Device.getInfo();
    if (this.util.isNative()) {
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: (await App.getInfo()).version,
      };

    } else {
      // Browser
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: webVersion
      }

    }
    this.userModel.device = this.deviceInfo
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: TermsComponent,
    });
    modal.present();

    const { data: _data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //alert(`Hello, ${data}!`);
    }
  }

  public startVideo() {
    console.log(this.isNative);
    console.log(this.isIos);

    if (!localStorage.getItem('USER_LOGGED')) {
      try {
        const videoElement = document.querySelector('video');
        if (videoElement) {
          videoElement.autoplay = true;
          const promise = videoElement.play();
          if (promise !== undefined) {
            promise.then(() => {
              console.log('Autoplay started!');
            }).catch(error => {
              console.log('Autoplay prevented:', error);
              throw new Error('Error in autoplay handling: ' + error.message);
            });
          }
        }

        console.log('Video started playing successfully');
      } catch (error) {
        console.error('Video play error:', error);
      }
    }

  }

  appleSignin() {
    if (!this.createAccountSocial) {
      this.analytics.trackLandingSocialLogin('apple');
    }
    this.processingAppleSignin = true;

    const options: SignInWithAppleOptions = {
      clientId: 'com.veggly',
      redirectURI: 'https://app.veggly.net/',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };

    SignInWithApple.authorize(options)
      .then(async (loginSuccess: SignInWithAppleResponse) => {

        this.loadingCtrl.create({
          message: this.translate.instant('msgOneMomentPlease'),
        });

        let userDataLocal: any = {
          appleUser: loginSuccess.response.user,
        }

        if (loginSuccess.response.givenName != undefined && loginSuccess.response.givenName != null && loginSuccess.response.givenName != null) {
          const _fullName = loginSuccess.response.givenName + loginSuccess.response.familyName;
          userDataLocal.firstName = loginSuccess.response.givenName;
          userDataLocal.lastName = loginSuccess.response.familyName;
        }

        userDataLocal.authorizationCode = loginSuccess.response.authorizationCode;
        userDataLocal.identityToken = loginSuccess.response.identityToken;

        if (loginSuccess.response.email !== '') {
          userDataLocal.email = loginSuccess.response.email;
          localStorage.setItem('USER_LOGGED', 'true')
          Preferences.set({ key: 'USER_DATA_APPLE', value: userDataLocal }).then((_val) => {
            console.log('userdataapple stored');
          });

        } else {
          await Preferences.get({ key: 'USER_DATA_APPLE' }).then((val) => {
            val = val.value ? JSON.parse(val.value) : null;
            if (val != null) {
              userDataLocal = val;
              localStorage.setItem('USER_LOGGED', 'true')
            }
            console.log('userdataapple that was stored: ' + JSON.stringify(userDataLocal));
          });
        }
        Preferences.get({ key: 'LAST_LOCATION' }).then(async (val) => {
          val = val.value ? JSON.parse(val.value) : null;
          let location = val;
          const teleportationLocation = this.locationService.getTeleportationLocation();
          if (teleportationLocation != null) {
            location = teleportationLocation;
          }

          // Retrieve and add FCM token to userData before sending to server
          const fcmToken = await Preferences.get({ key: 'TOKEN' });
          if (fcmToken && fcmToken.value) {
            userDataLocal.token = fcmToken.value;
          } else {
            const localToken = localStorage.getItem('TOKEN');
            if (localToken) {
              userDataLocal.token = localToken;
            }
          }

          this.userService.upsertSoul(userDataLocal, location, false, false, true)
            .subscribe(
              {
                next: async (data) => {

                  if (data == '{not ok}') {
                    console.log('upsert subscribe entered');
                    console.log('data returned from upsert: ' + data);
                    if (userDataLocal.email != undefined && userDataLocal.email != null) {

                      const alert = this.alertCtrl.create({
                        subHeader: this.translate.instant('createNewAccount'),
                        message: this.translate.instant('userWithEmailNotFound') + ' <b>' + userDataLocal.email + '</b>. ' + this.translate.instant('wouldYouLikeToCreateNew') + ' <a href="https://www.veggly.net/user-manual/#sign-in-with-apple">' + this.translate.instant('tryingToAccessExisting') + '</a>?',
                        buttons: [
                          {
                            text: this.translate.instant('cancel'),
                            handler: () => {
                              this.loadingCtrl.dismiss();
                              this.processingAppleSignin = false;
                            }
                          },
                          {
                            text: this.translate.instant('confirm'),
                            handler: () => {
                              userDataLocal.createConfirmed = true;
                              this.attachReferralUserId(userDataLocal);
                              this.userService.upsertSoul(userDataLocal, location, false, false, true).subscribe(
                                {
                                  next: async (data) => {
                                    console.log('createConfirmed upsert subscribe entered');
                                    console.log('data returned from createConfirmed upsert: ' + data);

                                    if (data == '{not ok}') {
                                      console.log('createConfirmed Upsert error: ');
                                      return;
                                    }

                                    console.log("============USER APPLE CREATED=========");
                                    console.log(this.userData);

                                    this.userData = JSON.parse(data);

                                    this.registerLoginEvents();
                                    this.saveProfile(null);

                                  },
                                  error: (erro) => {
                                    console.log('Upsert error: ' + JSON.stringify(erro.toString()));
                                    this.loadingCtrl.dismiss();
                                    this.util.showToastUnableToConnect(this.toastCtrl);
                                    this.processingAppleSignin = false;
                                  }
                                }
                              );
                              return;
                            }
                          }
                        ]
                      });
                      (await alert).present();

                    } else { // No email was sent to server. User already signed in on device and account not found in our server
                      const alert = this.alertCtrl.create({
                        subHeader: this.translate.instant('accountNotFoundOnVeggly'),
                        message: this.translate.instant('ifYouWouldLikeNewStopAppleId'),
                        buttons: [
                          {
                            text: 'OK',
                            handler: () => {
                              //this.loader.dismiss();
                            }
                          }
                        ]
                      });
                      (await alert).present();
                    }

                  } else {

                    const resultJSON: any = JSON.parse(data);
                    if (resultJSON.login != undefined && resultJSON.login != null && resultJSON.login == 'invalid') {
                      this.showModalAlert(this.translate.instant('invalidLogin'));
                      this.processingAppleSignin = false;
                      return;
                    } else {

                      this.userData = resultJSON;
                      this.userModel = this.userData;

                      this.registerLoginEvents();
                      this.saveProfile(null);
                    }
                  }
                },
                error: (erro) => {
                  console.log(erro);
                  this.processingAppleSignin = false;
                }
              }
            )
        },
          error => {
            console.error(JSON.stringify(error))
            console.log(JSON.stringify(error))
            this.processingAppleSignin = false;
          });

      }, (reason: any) => {
        console.log(reason);
        this.processingAppleSignin = false;
      })
      .catch(error => {
        console.error(JSON.stringify(error))
        console.log(JSON.stringify(error))
        this.processingAppleSignin = false;
      });


  }

  async appleSigninNew() {
    // const loading = await this.loadingCtrl.create({
    //   message: 'Dismissing after 3 seconds...',
    //   duration: 3000,
    // });
    // loading.present();

    const options: SignInWithAppleOptions = {
      clientId: 'com.veggly',
      redirectURI: 'https://app.veggly.net/',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };

    SignInWithApple.authorize(options)
      .then((_result: SignInWithAppleResponse) => {

      })
      .catch(_error => {
        // Handle error
      });

  }

  async showLoading(message: string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      translucent: true,

      backdropDismiss: true
    });

    loading.present();
  }

  async googleSignIn() {
    if (!this.createAccountSocial) {
      this.analytics.trackLandingSocialLogin('google');
    }
    // WEB: gapi.auth2 foi desligado pelo Google → usa GIS (ID token flow) → googleIdToken,
    // que é o que o backend valida. Nativo segue no plugin.
    if (!Capacitor.isNativePlatform()) {
      await this.googleSignInWeb();
      return;
    }

    this.processingGoogleSignin = true;

    try {
      console.log('Iniciando login do Google...');

      let clientId: string = '';

      if (!Capacitor.isNativePlatform()) {
        clientId = environment.googleAuth.web;
        console.log('Plataforma: Web, Client ID:', clientId);
      } else if (this.isIos) {
        clientId = environment.googleAuth.ios;
        console.log('Plataforma: iOS, Client ID:', clientId);
      } else {
        clientId = environment.googleAuth.android;
        console.log('Plataforma: Android, Client ID:', clientId);
      }

      console.log('Inicializando Google Auth...');
      await GoogleAuth.initialize({
        clientId: clientId,
        scopes: ['profile', 'email'],
        grantOfflineAccess: true,
      });
      console.log('Google Auth inicializado com sucesso');

      console.log('Tentando fazer login...');
      const googleUser = await GoogleAuth.signIn({ scopes: ['profile', 'email'], serverClientId: environment.googleAuth.web });
      console.log('Google Authentication Result:', googleUser);
      // Handle authentication success
      if (googleUser.email == undefined || googleUser.email == null || googleUser.email == '') {
        this.showModalAlert(this.translate.instant('googleNoEmail'));
        this.processingGoogleSignin = false;
        return;
      }

      this.userData = {
        email: googleUser.email
      };

      if ((googleUser as any).googleUserId != null) {
        this.userData.googleUserId = (googleUser as any).googleUserId
      }
      if (googleUser.name != null) {
        this.userData.displayName = googleUser.name
      }
      if (googleUser.givenName != null) {
        this.userData.firstName = googleUser.givenName
      }
      if (googleUser.familyName != null) {
        this.userData.lastName = googleUser.familyName
      }
      if (googleUser.authentication.refreshToken != null) {
        this.userData.googleRefreshToken = googleUser.authentication.refreshToken
      }
      if (googleUser.serverAuthCode != null) {
        this.userData.googleServerAuthCode = googleUser.serverAuthCode
      }

      if (googleUser.authentication.accessToken != null) {
        this.userData.googleAccessToken = googleUser.authentication.accessToken
      }
      if (googleUser.authentication.idToken != null) {
        this.userData.googleIdToken = googleUser.authentication.idToken
      }

      console.log('Dados do usuário processados:', this.userData);
      this.registerLoginEvents();
      this.saveProfile(null);

    } catch (error) {
      console.error('Google Authentication Error:', error);
      this.showModalAlert(((error as any).message || 'Unknown Error'));
      this.processingGoogleSignin = false;
    }
  }

  /**
   * Login Google na WEB via Google Identity Services (ID token flow).
   * Obtém o JWT (googleIdToken, validado no backend) e decodifica email/nome/sub para
   * manter o mesmo payload do fluxo nativo. Substitui o gapi.auth2 desligado pelo Google.
   */
  private async googleSignInWeb() {
    this.processingGoogleSignin = true;
    try {
      const idToken = await this.googleWebAuth.signInGetIdToken(environment.googleAuth.web);
      const claims = this.googleWebAuth.decodeIdToken(idToken);

      if (!claims || claims.email == null || claims.email === '') {
        this.showModalAlert(this.translate.instant('googleNoEmail'));
        this.processingGoogleSignin = false;
        return;
      }

      this.userData = { email: claims.email };
      this.userData.googleIdToken = idToken;
      if (claims.sub != null) {
        this.userData.googleUserId = claims.sub;
      }
      if (claims.name != null) {
        this.userData.displayName = claims.name;
      }
      if (claims.given_name != null) {
        this.userData.firstName = claims.given_name;
      }
      if (claims.family_name != null) {
        this.userData.lastName = claims.family_name;
      }

      this.registerLoginEvents();
      this.saveProfile(null);
    } catch (error) {
      console.error('Google Authentication Error (web):', error);
      this.showModalAlert(((error as any).message || 'Unknown Error'));
      this.processingGoogleSignin = false;
    }
  }

  async loginWithFB() {
    if (!this.createAccountSocial) {
      this.analytics.trackLandingSocialLogin('facebook');
    }
    this.processingFacebookSignin = true;
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
      duration: 3000,
    });

    try {
      await loading.present();

      if (!Capacitor.isNativePlatform()) {
        try {
          await FacebookLogin.initialize({ appId: '958355687655700' });
        } catch (initError) {
          console.log('Facebook already initialized or init error:', initError);
        }
      }

      const { token, type } = await this.facebookService.login();
      if (token) {
        const facebookUser: FacebookUser = await this.facebookService.getUserData(token, type);
        console.log('User Data:', facebookUser);
        this.userData = facebookUser;
        this.userData.facebookAccessToken = token;
        this.userData.facebookLoginType = type;
        this.registerLoginEvents();
        this.saveProfile(facebookUser?.picture?.data?.url || null);
      } else {
        console.error('Falha no login do Facebook - sem access token');
        this.showModalAlert('Facebook login error. Try again.');
        this.processingFacebookSignin = false;
        await loading.dismiss();
      }
    } catch (error) {
      console.error('Erro ao fazer login no Facebook:', error);
      this.showModalAlert(((error as any).message || 'Unknown Error'));
      this.processingFacebookSignin = false;
      await loading.dismiss();
    }
  }




  private async saveProfile(localPicture: any) {
    const lastLocation = await Preferences.get({ key: 'LAST_LOCATION' });
    let location = lastLocation?.value ? JSON.parse(lastLocation.value) : { type: 'Point', coordinates: [environment.locationDefault.coordinates[0], environment.locationDefault.coordinates[1]] };
    const teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      location = teleportationLocation;
    }

    // Retrieve and add FCM token to userData before sending to server
    const fcmToken = await Preferences.get({ key: 'TOKEN' });
    if (fcmToken && fcmToken.value) {
      this.userData.token = fcmToken.value;
    } else {
      const localToken = localStorage.getItem('TOKEN');
      if (localToken) {
        this.userData.token = localToken;
      }
    }

    // Same as LoginSharedPage: stamp pending/URL referral on Google/FB so the
    // referrer is credited on create. Backend ignores referral on returning login.
    this.attachPendingReferralUserId(this.userData);
    this.userService
      .upsertSoul(this.userData, location, false, false, true)
      .subscribe(
        {
          next: async (data) => {
            if (data != '{not ok}') {
              this.userModel = JSON.parse(data);

              // Send image to Server
              const serverPicture = this.userData.picture0;

              if (localPicture != null && serverPicture == null) {
                this.userData = JSON.parse(data);
                this.http.get(localPicture, { responseType: 'blob' })
                  .subscribe(
                    {
                      next: (response: Blob) => {
                        const fileReader = new FileReader();
                        const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
                        const reader = zoneOriginalInstance || fileReader;

                        reader.onloadend = async () => {
                          const uploadImageFB = this.setFirstPicture();
                          if (uploadImageFB) {
                            this.imageFB = reader.result as string;
                            const filename: string = 'picture' + 0;
                            this.userService
                              .uploadImage64(this.imageFB, this.userModel, filename)
                              .subscribe(
                                {
                                  next: async (data) => {
                                    this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                                    this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                                    this.userModel.filename = { '$oid': data };
                                    this.userModel.picture0 = { '$oid': data };
                                    await this.storeUserLocally();
                                  },
                                  error: (_err) => {
                                    //alert('uploadImage error: ' + JSON.stringify(err));
                                  }
                                }
                              )
                          } else {
                            this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                            this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                            await this.storeUserLocally();
                          }

                        }


                        reader.readAsDataURL(response);

                      },
                      error: (erro) => {
                        //alert("Usuário ou Senha inválido(s)!");
                        console.log(erro)
                      }
                    }
                  )
              } else {
                this.userData = JSON.parse(data);
                await this.storeUserLocally();
              }
            }
          },
          error: (erro) => {
            //alert("Usuário ou Senha inválido(s)!");
            console.log(erro)
            this.processingGoogleSignin = false;
            this.processingFacebookSignin = false;
            this.processingAppleSignin = false;
          }
        }
      )



  }

  setFirstPicture() {
    let picnum: number;
    let picCount: number = 0;
    const data2: any = this.userModel
    for (picnum = 0; picnum < 9; picnum++) {
      const aPic: string = "picture" + picnum;
      if (data2[aPic]) {
        picCount++;
      }
    }
    if (picCount == 0) {
      return true;
    }
    return false
  }




  async showModalAlert(message: string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }

  showWelcomeBackMsg() {
    if (this.userModel.wasOnHibernate != null) {
      this.showModalAlert(this.translate.instant('welcomeBackFromHibernate'));
      delete this.userModel.wasOnHibernate;

      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
        console.log('login.showWelcomeBackMsg: saved user without the wasOnHibernate');
      });
    }
  }

  private async storeUserLocally() {
    // Mesmo usuário logando de novo: restaura teletransporte (backup primeiro, depois userData do servidor)
    const userToRestore = this.userData || this.userModel;
    await this.locationService.restoreTeleportationFromBackup(userToRestore);
    if (!this.locationService.getTeleportationLocation()) {
      await this.locationService.restoreTeleportationFromUserData(userToRestore);
    }
    const teleportLoc = this.locationService.getTeleportationLocation();
    if (teleportLoc) {
      this.userModel.location = teleportLoc;
      this.userModel.usingTeleportation = true;
    }

    // userModel é a fonte canônica pós-login (inclui hash, _id e mutações de upload de imagem).
    // Sincroniza userData e persiste USER_DATA numa única escrita atômica.
    this.userData = { ...this.userModel };
    console.log('Stored UserData = ' + JSON.stringify(this.userData));
    await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });

    console.log('Will set UserService.loggedOut to false. Current value: ' + UserService.loggedOut);
    UserService.loggedOut = false;
    this.processingGoogleSignin = false;
    this.processingFacebookSignin = false;
    this.processingAppleSignin = false;
    this.restartMatchService();
    localStorage.setItem('USER_LOGGED', 'true');
    await Preferences.set({ key: 'USER_LOGGED', value: 'true' });
    await this.trackCreateAccountSocialSignup();
    this.showWelcomeBackMsg();

    if (this.userData.interest2 != null) {
      this.router.navigateByUrl('/tabs/home');
    } else {
      this.router.navigateByUrl('/tabs/my-profile-display');
    }
  }

  registerLoginEvents() {
    // Your logic for registering login events
    Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (this.userService.checkUserHasPicture(val)) {
        this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
        if (val.sign_up_compl_ok)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpComplOk, true);
        if (val.valuable_user_1d)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuable1d, true);
        if (val.valuable_user)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuable, true);
      }
    })
  }

  showJoinOptions() {
    this.showWebAuthentication = true;
  }

  hideJoinOptions() {
    this.showWebAuthentication = false;
  }

  showExistingLogin() {
    this.showNativeWebLogin = true;
  }

  hideExistingLogin() {
    this.showNativeWebLogin = false;
  }

  private loadAffiliateLanding() {
    const referralUserId = this.userService.extractReferralUserId(window.location.href);
    if (!referralUserId) {
      return;
    }
    // Keep default copy visible immediately; replace only if custom HTML arrives.
    this.userService.getAffiliateLanding(referralUserId).subscribe({
      next: (landing: any) => {
        const html = (landing?.html || '').trim();
        // Prefer an explicit backend flag; fall back to stock-copy heuristic.
        // Pass raw HTML through [innerHTML] so Angular's sanitizer stays on
        // (do not bypassSecurityTrustHtml on affiliate-controlled content).
        const useTemplateDefault =
          landing?.isDefault === true || this.isStockDefaultLandingHtml(html);
        this.affiliateLandingHtml = useTemplateDefault ? '' : html;
      },
      error: () => {
        this.affiliateLandingHtml = '';
      }
    });
  }

  /**
   * Prefer `landing.isDefault` from the API. EN-only text heuristic is a
   * best-effort fallback while some routes omit the flag — localized stock
   * HTML will not match and should be fixed by sending `isDefault: true`.
   * Angular sanitizes [innerHTML] (no bypassSecurityTrustHtml).
   */
  private isStockDefaultLandingHtml(html: string): boolean {
    if (!html) {
      return true;
    }
    const text = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    return text.includes('vegan & vegetarian dating')
      && text.includes('meet someone who wants something real')
      && text.includes('veggly brings thoughtful vegans and vegetarians together')
      && text.length < 250;
  }

  async openProfile() {
    this.router.navigateByUrl('/tabs/home');
  }
  async openDefaultLogin() {
    this.router.navigateByUrl('/default-login');
  }

  async openSignup() {
    const referralUserId = this.resolvePendingReferralUserId();
    this.router.navigate(['/signup-with-email'], {
      queryParams: referralUserId ? { referralUserId } : {}
    });
  }

  /** URL query (web) or pending attribution (native deep link / prior capture). */
  private resolvePendingReferralUserId(): string | null {
    const fromUrl = this.userService.extractReferralUserId(window.location.href);
    const fromAttribution = this.userService.getPendingAcquisitionAttribution()?.['referralUserId'];
    return fromUrl || fromAttribution || null;
  }

  /** Stamp referral on Google/FB upsert payload (parity with LoginSharedPage). */
  private attachPendingReferralUserId(userData: Record<string, unknown>): void {
    if (userData?.['referralUserId']) {
      return;
    }
    const referralUserId = this.resolvePendingReferralUserId();
    if (referralUserId) {
      userData['referralUserId'] = referralUserId;
    }
  }

  /** Apple native createConfirmed only — credits referrer after explicit create. */
  private attachReferralUserId(userData: Record<string, unknown>): void {
    // Only after the user confirms account creation (Apple createConfirmed).
    // Apple Sign-In is native-only (login.page.html isIos && isNative).
    // Pending attribution is filled from App.getLaunchUrl / appUrlOpen on native.
    if (!userData?.['createConfirmed']) {
      return;
    }
    this.attachPendingReferralUserId(userData);
  }

  async handleCreateAccountClick() {
    try {
      const variant = await this.onboardingService.getVariant();
      await this.onboardingService.trackAbTestEntry(variant, 'create_account_button');

      if (variant === 'test') {
        const resumable = await this.onboardingService.hasResumableProgress();
        if (!resumable) {
          await this.onboardingService.initializeProgress('test');
        }
        this.router.navigate(['/onboarding-flow']);
        return;
      }

      await this.onboardingService.initializeProgress('control');
      await this.openSignupWithEmailModal();
    } catch (error) {
      console.error('Create account flow failed:', error);
      await this.openSignupWithEmailModal();
    }
  }

  private async openSignupWithEmailModal() {
    UtilService.loggedOut = false;
    const referralUserId = this.resolvePendingReferralUserId();
    const modal = await this.modalCtrl.create({
      component: SignupWithEmailPage,
      componentProps: referralUserId ? { referralUserId } : {},
    });
    modal.onDidDismiss().then((val) => {
      if (val && val.data === 'loggedIn') {
        UserService.loggedOut = false;
        this.router.navigateByUrl('/tabs/my-profile-display');
        return;
      }
      if (val?.data?.social) {
        void this.startCreateAccountSocial(val.data.social);
      }
    });
    await modal.present();
  }

  private async trackCreateAccountSocialSignup(): Promise<void> {
    if (!this.createAccountSocial) {
      return;
    }
    const method = this.createAccountSocial;
    this.createAccountSocial = null;
    const progress = this.onboardingService.getCurrentProgress()
      || await this.onboardingService.loadProgress();
    if (progress) {
      await this.onboardingService.trackSignup(method, this.userData);
      await this.onboardingService.clearProgress();
    }
  }

  private async startCreateAccountSocial(provider: 'google' | 'facebook' | 'apple'): Promise<void> {
    this.createAccountSocial = provider;
    if (provider === 'google') {
      await this.googleSignIn();
    } else if (provider === 'facebook') {
      await this.loginWithFB();
    } else {
      this.appleSignin();
    }
  }


  private restartMatchService() {
    this.matchService.restartRefresh();
  }
}